module.exports = "/static/fonts/Framework7Icons-Regular.0628928.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/framework7-icons/fonts/Framework7Icons-Regular.ttf
// module id = 1122
// module chunks = 2